import * as Yup from 'yup';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import PgTaxes1YearAgoValidation from './PgTaxes1YearAgoValidation';
import PgExtension1YearAgoValidation from './PgExtension1YearAgoValidation';
import PgTaxes2YearsAgoValidation from './PgTaxes2YearsAgoValidation';
import PgExtension2YearsAgoValidation from './PgExtension2YearsAgoValidation';
import PgTaxes3YearsAgoValidation from './PgTaxes3YearsAgoValidation';
import PgExtension3YearsAgoValidation from './PgExtension3YearsAgoValidation';
import PgFiledTaxes1YearAgoValidation from './PgFiledTaxes1YearAgoValidation';
import PgFiledTaxes2YearsAgoValidation from './PgFiledTaxes2YearsAgoValidation';
import PgFiledTaxes3YearsAgoValidation from './PgFiledTaxes3YearsAgoValidation';

export class PrincipalsStage2Validation implements ValidationSchema {
  public name = 'principals';
  public label = '';
  public dependsOn: string[] = [];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = false;

  public when(schema: Yup.ArraySchema<Yup.ObjectSchema<any>>) {
    return schema.of(
      Yup.object().shape({
        [PgFiledTaxes1YearAgoValidation.name]:
          PgFiledTaxes1YearAgoValidation.buildSchema(),
        [PgFiledTaxes2YearsAgoValidation.name]:
          PgFiledTaxes2YearsAgoValidation.buildSchema(),
        [PgFiledTaxes3YearsAgoValidation.name]:
          PgFiledTaxes3YearsAgoValidation.buildSchema(),
        documents: Yup.object().shape({
          [PgTaxes1YearAgoValidation.name]:
            PgTaxes1YearAgoValidation.buildSchema(),
          [PgExtension1YearAgoValidation.name]:
            PgExtension1YearAgoValidation.buildSchema(),
          [PgTaxes2YearsAgoValidation.name]:
            PgTaxes2YearsAgoValidation.buildSchema(),
          [PgExtension2YearsAgoValidation.name]:
            PgExtension2YearsAgoValidation.buildSchema(),
          [PgTaxes3YearsAgoValidation.name]:
            PgTaxes3YearsAgoValidation.buildSchema(),
          [PgExtension3YearsAgoValidation.name]:
            PgExtension3YearsAgoValidation.buildSchema(),
        }),
      })
    );
  }
}
export default new Validation(new PrincipalsStage2Validation());
